<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <g v-if="weight === 'THIN'">
            <path
                d="M13.8 19.5516H19.8M4.20007 19.5516L8.56606 18.6719C8.79784 18.6252 9.01065 18.511 9.17779 18.3438L18.9515 8.56477C19.4201 8.09592 19.4197 7.33593 18.9508 6.86747L16.8803 4.79939C16.4115 4.33113 15.6519 4.33145 15.1835 4.80011L5.40884 14.5802C5.24202 14.7471 5.12812 14.9594 5.08138 15.1907L4.20007 19.5516Z"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <g v-else-if="weight === 'REGULAR'">
            <path
                d="M13.8 19.5516H19.8M4.20007 19.5516L8.56606 18.6719C8.79784 18.6252 9.01065 18.511 9.17779 18.3438L18.9515 8.56477C19.4201 8.09592 19.4197 7.33593 18.9508 6.86747L16.8803 4.79939C16.4115 4.33113 15.6519 4.33145 15.1835 4.80011L5.40884 14.5802C5.24202 14.7471 5.12812 14.9594 5.08138 15.1907L4.20007 19.5516Z"
                stroke="currentColor"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <g v-else>
            <path
                d="M13.8 19.5516H19.8M4.20007 19.5516L8.56606 18.6719C8.79784 18.6252 9.01065 18.511 9.17779 18.3438L18.9515 8.56477C19.4201 8.09592 19.4197 7.33593 18.9508 6.86747L16.8803 4.79939C16.4115 4.33113 15.6519 4.33145 15.1835 4.80011L5.40884 14.5802C5.24202 14.7471 5.12812 14.9594 5.08138 15.1907L4.20007 19.5516Z"
                fill="currentColor"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'edit-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'REGULAR',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>


